import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CorsiService } from 'app/main/pages/academy/corsi.service';
import { environment } from 'environments/environment';
import { from, Observable } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import { Costanti, CostantiStorage } from '../costanti';
import { SessioneUtenteQuery } from '../state';
import { Utils } from '../utils';

export interface AsyncHttpInterceptor extends HttpInterceptor {
  interceptAsync(req: HttpRequest<any>, next: HttpHandler): Promise<Observable<HttpEvent<any>>>;
}

@Injectable()
export class JWTRequestInterceptor implements AsyncHttpInterceptor {
  constructor(
    private sessioneUtenteQuery: SessioneUtenteQuery,
    private corsiService: CorsiService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.interceptAsync(req, next)).pipe(flatMap(o => o));
  }

  async interceptAsync(req: HttpRequest<any>, next: HttpHandler): Promise<Observable<HttpEvent<any>>> {
    const JWT = 'Bearer ' + localStorage.getItem(CostantiStorage.TOKEN);
    const body = req.body;

    const isServerStampa =
      ~req.url.indexOf('stampaserver.exacloud') ||
      ~req.url.indexOf('stampaserver.exabytesoftware') ||
      ~req.url.indexOf('googleapis');
    const isServerCorsi = ~req.url.indexOf('api/corsi') || ~req.url.indexOf('api/gdpr') || ~req.url.indexOf('api/8108');
    const isNppApi = req.url.indexOf(Costanti.NPP_APIURL) === 0;
    // Con FormData il Content-Type (multipart + boundary) lo imposta il browser.
    const isMultipart = body instanceof FormData;

    const newHeaders = {};
    if (!isServerStampa) {
      // newHeaders['Content-Type'] = req.headers.get('Content-Type') === null ? 'application/json' : req.headers.get('Content-Type');
      if (!isMultipart) {
        newHeaders['Content-Type'] = req.headers.get('Content-Type') || 'application/json';
      }
      newHeaders['Authorization'] = JWT;
    }
    if (isServerCorsi) {
      if (~req.url.indexOf('corsi/set_token')) {
        // newHeaders['authToken'] = 'E4B5CBD718F1B413ABCF699E308823B62DFE5911B0BD5D057A3728ECB11F2F57';
      } else {
        if (environment.corsiBackdoorEnabled) {
          newHeaders['exaBackdoor'] = environment.corsiBackdoor;
        } else {
          let token = Utils.safe(this.sessioneUtenteQuery.loggedUser()).token_corsi;
          if (!token) {
            const tokenData = await this.corsiService.setToken().toPromise();
            if (tokenData.set_token && tokenData.set_token.loginToken) {
              const loginToken = tokenData.set_token.loginToken;
              token = loginToken;
              this.sessioneUtenteQuery.setTokenCorsi(loginToken);
            }
          }
          if (token) {
            newHeaders['Token'] = token;
          }
        }
      }
    }
    let noHeader = false;
    const urlExclude = ['import-excel-sistema-ts', 'https://aimuwclone2produzione.brokerver.com/quotr/sso.jsp'];
    for (const tmp of urlExclude) {
      noHeader = req.url.includes(tmp);
      if (noHeader) {
        break;
      }
    }
    req = req.clone({
      setHeaders: noHeader ? {} : newHeaders,
      withCredentials: !isServerStampa && !isNppApi,
      body: body
    });
    return next.handle(req);
  }
}
